export * from './chart.directive';
export * from './chart.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/charts/index.js
// module id = ../../../../angular-bootstrap-md/charts/index.js
// module chunks = 3